import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/window-restore': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M464 0H144C117.5 0 96 21.5 96 48V96H48C21.5 96 0 117.5 0 144V464C0 490.5 21.5 512 48 512H368C394.5 512 416 490.5 416 464V416H464C490.5 416 512 394.5 512 368V48C512 21.5 490.5 0 464 0zM368 464H48V256H368V464zM464 368H416V144C416 117.5 394.5 96 368 96H144V48H464V368z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/window-restore.js
// module id = v2MC
// module chunks = 144